module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Origem de Contato")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'policiacivil.processo.origem-contato.list'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "tipo-impeditiva"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ativo),
      expression: "data.ativo"
    }],
    attrs: {
      "id": "tipo-impeditiva",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.ativo) ? _vm._i(_vm.data.ativo, null) > -1 : (_vm.data.ativo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "ativo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "ativo", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'policiacivil.processo.origem-contato.list'
        })
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e692050","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/processo/origem-contato/components/NovaOrigemContato.vue
// module id = 1767
// module chunks = 18